import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.scss'
import './i18n'
import App from './App.tsx'
import { ApplicationContextProvider } from './contexts/ApplicationContext.tsx';

const eventContainer = document.getElementById('root')!;
const eventId = eventContainer.getAttribute('data-event') ?? '';
const eventView = eventContainer.getAttribute('data-event-view') ?? '';
const ticketCategory = eventContainer.getAttribute('data-ticket-category') ?? '';

createRoot(eventContainer).render(
  <StrictMode>
    <ApplicationContextProvider props={{eventId: eventId, eventView: eventView, ticketCategory: ticketCategory}}>
      <App />
    </ApplicationContextProvider>
  </StrictMode>,
)
